import React from "react";
import "./ProductBox.css"; 

const ProductBox = ({ product }) => {
  // Format the price with commas
  const formattedPrice = (price) => {
    return new Intl.NumberFormat().format(price);
  };

  // Determine the price to display (monthly first, then annually)
  const displayPrice = product.monthly 
    ? formattedPrice(product.monthly) 
    : product.annually 
    ? formattedPrice(product.annually) 
    : formattedPrice(product.an_hour);

  return (
    <div className="product-box bg-transparent text-white shadow-md p-6 rounded-[30px] border border-gray-500 w-72 transition duration-500 ease-in-out transform hover:scale-105 hover-gradient flex flex-col justify-between h-full group"> {/* Add group here */}
      <div>
        <h3 className="lg:text-[15px] md:text-[14px] sm:text-[12px] font-semibold mb-4">{product.title}</h3>
        <ul className="list-none mb-4 lg:text-[14px] md:text-[12px] sm:text-[10px]" dir="rtl"> {/* Set the list direction to RTL */}
          {product.features.map((feature, index) => (
            <li
              key={index}
              className="mb-2 relative pr-6 before:content-['•'] before:absolute before:right-0 before:text-white group-hover:before:text-black before:text-lg leading-6 md:leading-8"
              dangerouslySetInnerHTML={{ __html: feature.name }}
            ></li>
          ))}
        </ul>
      </div>
      <div className="mt-auto text-lg font-bold flex justify-between items-center product-wrapper">
      <a
          href={product.slug}
          className="bg-blue-500 hover:bg-blue-600 text-black font-bold py-2 px-4 w-28 text-center purchase-button sm:mr-4 sm:w-32 security-site"
        >
          خرید
        </a>
        <div className="wrapperPrice text-[17px] sm:text-[14px]">
          <span className="p-1">
            {displayPrice}
          </span>
          {product.currency.suffix}
        </div>

       
      </div>
    </div>
  );
};

export default ProductBox;